// src/ui/textHelper.ts
//
// Phase 12 (UI-09): DPR-aware Text factory. Wraps `scene.add.text()` to set
// per-Text `resolution: window.devicePixelRatio` so text renders crisp on
// retina laptops without per-call-site copy-paste. Phaser 3.50+ removed the
// top-level `resolution` config option; per-Text resolution is the canonical fix.
//
// Floor at 2 to keep text crisp on low-DPR Macs and external monitors during
// development; cap is implicit (no `Math.min`) since real DPR rarely exceeds 3.

import Phaser from 'phaser';

/**
 * Add a Phaser Text GameObject with per-instance DPR resolution applied.
 *
 * Use anywhere `scene.add.text(...)` would be called. Returns the Text object
 * so chaining (`.setOrigin(0.5).setDepth(50)`) works as before.
 */
export function addCrispText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  style: Phaser.Types.GameObjects.Text.TextStyle = {},
): Phaser.GameObjects.Text {
  return scene.add.text(x, y, text, {
    ...style,
    resolution: Math.max(2, window.devicePixelRatio || 1),
  });
}
